export const ADD_NEW_MESSAGE = "ADD_NEW_MESSAGE";
export const CLEAR_NEW_MESSAGES = "CLEAR_NEW_MESSAGES";
export const SET_IS_RELOAD_NOTIFICATIONS = "SET_IS_RELOAD_NOTIFICATIONS";
export const SET_IS_RELOAD_JOBS = "SET_IS_RELOAD_JOBS";

export const addNewMessage = notification => ({
    type: ADD_NEW_MESSAGE,
    payload: notification
});

export const clearNewMessages = () => ({
    type: CLEAR_NEW_MESSAGES
});

export const setIsReloadNotifications = isReloadNotifications => ({
    type: SET_IS_RELOAD_NOTIFICATIONS,
    payload: isReloadNotifications
});

export const setIsReloadJobs = isReloadJobs => ({
    type: SET_IS_RELOAD_JOBS,
    payload: isReloadJobs
});